module.exports = __webpack_public_path__ + "img/blue-1.c8ba560c.svg";